var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-faq",modifiers:{"modal-faq":true}}],attrs:{"right":""}},[_vm._v("FAQ")])
}
var staticRenderFns = []

export { render, staticRenderFns }